import { render, staticRenderFns } from "./RequestHandlingStep.vue?vue&type=template&id=c4c07424&scoped=true&"
import script from "./RequestHandlingStep.vue?vue&type=script&lang=js&"
export * from "./RequestHandlingStep.vue?vue&type=script&lang=js&"
import style0 from "./RequestHandlingStep.vue?vue&type=style&index=0&id=c4c07424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c07424",
  null
  
)

export default component.exports